module.exports = __webpack_public_path__ + "static/media/immeuble-devant-front.4be28ce7.png";